import { createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-48e8088c")

_pushScopeId("data-v-48e8088c")
const _hoisted_1 = { class: "shoppinglist-search-input-view" }
const _hoisted_2 = { class: "commonSearchInputViewArea" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "commonSearchIconArea" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "commonSearchIcon",
    src: _imports_0
  })
], -1)
const _hoisted_4 = { class: "shoppinglist-search-input-view-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        ref: "textInput",
        class: "commonSearchText",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keywordComputed = $event)),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setFocusKeyword(...args))),
        placeholder: "テキストを入力",
        enterkeyhint: "done",
        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleEnter()), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.keywordComputed]
      ]),
      (!_ctx.isValidFocus)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setSearchedText(...args))),
            class: "shoppinglist-search-input-view-button"
          }, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.searchButtonText), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})